import React from 'react';
import { AppAuthenticatedContext } from '../../providers/AppAuthenticatedProvider';

/**
 * Provides global authenticated user context & global modals
 */
export function useAuthenticated() {
  const context = React.useContext(AppAuthenticatedContext);
  if (context === undefined) {
    throw new Error(
      'useAuthenticated must be used within a AppAuthenticatedContext.Provider'
    );
  }
  return context;
}
